import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full p-6" }
const _hoisted_2 = { class: "flex items-center gap-8 mb-6" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = { class: "text-2xl font-bold mb-2" }
const _hoisted_5 = { class: "text-primary" }
const _hoisted_6 = { class: "text-muted-foreground" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = { class: "flex space-x-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ForecastingPCODashboard = _resolveComponent("ForecastingPCODashboard")!
  const _component_ForecastingPCOCalendar = _resolveComponent("ForecastingPCOCalendar")!
  const _component_ForecastingPCODocuments = _resolveComponent("ForecastingPCODocuments")!
  const _component_ForecastingPCOPresentation = _resolveComponent("ForecastingPCOPresentation")!
  const _component_EmailReviewModal = _resolveComponent("EmailReviewModal")!
  const _component_SpreadsheetReviewModal = _resolveComponent("SpreadsheetReviewModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, [
          _cache[4] || (_cache[4] = _createTextVNode(" Forecasting for PCO - ")),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.forecastingPcoTab === 'dashboard' ? 'Dashboard' :
                            _ctx.forecastingPcoTab === 'calendar' ? 'Calendar' :
                                _ctx.forecastingPcoTab === 'documents' ? 'Documents' :
                                    'Presentation'), 1)
        ]),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.forecastingPcoTab === 'dashboard' ? 'Analyze and manage financial forecasts for the Planning and Controlling Office' :
                        _ctx.forecastingPcoTab === 'calendar' ? 'View and manage your forecasting calendar and upcoming meetings' :
                            _ctx.forecastingPcoTab === 'documents' ? 'Track and manage your forecasting documents and their status' :
                                'Create and manage presentation slides for your forecasting reports'), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("nav", _hoisted_8, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateToTab('dashboard'))),
            class: _normalizeClass(["py-2 px-4 font-medium text-sm focus:outline-none", _ctx.forecastingPcoTab === 'dashboard' ? 'border-b-2 border-primary text-primary' : 'text-muted-foreground hover:text-foreground hover:border-b-2 hover:border-muted-foreground'])
          }, " Dashboard ", 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateToTab('calendar'))),
            class: _normalizeClass(["py-2 px-4 font-medium text-sm focus:outline-none", _ctx.forecastingPcoTab === 'calendar' ? 'border-b-2 border-primary text-primary' : 'text-muted-foreground hover:text-foreground hover:border-b-2 hover:border-muted-foreground'])
          }, " Calendar ", 2),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateToTab('documents'))),
            class: _normalizeClass(["py-2 px-4 font-medium text-sm focus:outline-none", _ctx.forecastingPcoTab === 'documents' ? 'border-b-2 border-primary text-primary' : 'text-muted-foreground hover:text-foreground hover:border-b-2 hover:border-muted-foreground'])
          }, " Documents ", 2),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateToTab('presentation'))),
            class: _normalizeClass(["py-2 px-4 font-medium text-sm focus:outline-none", _ctx.forecastingPcoTab === 'presentation' ? 'border-b-2 border-primary text-primary' : 'text-muted-foreground hover:text-foreground hover:border-b-2 hover:border-muted-foreground'])
          }, " Presentation ", 2)
        ])
      ])
    ]),
    (_ctx.forecastingPcoTab === 'dashboard')
      ? (_openBlock(), _createBlock(_component_ForecastingPCODashboard, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.forecastingPcoTab === 'calendar')
      ? (_openBlock(), _createBlock(_component_ForecastingPCOCalendar, {
          key: 1,
          userData: _ctx.userData
        }, null, 8, ["userData"]))
      : _createCommentVNode("", true),
    (_ctx.forecastingPcoTab === 'documents')
      ? (_openBlock(), _createBlock(_component_ForecastingPCODocuments, {
          key: 2,
          onOpenEmailModal: _ctx.openEmailReviewModal,
          onOpenSpreadsheetModal: _ctx.openSpreadsheetReviewModal
        }, null, 8, ["onOpenEmailModal", "onOpenSpreadsheetModal"]))
      : _createCommentVNode("", true),
    (_ctx.forecastingPcoTab === 'presentation')
      ? (_openBlock(), _createBlock(_component_ForecastingPCOPresentation, { key: 3 }))
      : _createCommentVNode("", true),
    _createVNode(_component_EmailReviewModal, {
      "is-open": _ctx.showEmailReviewModal,
      "process-step-type": _ctx.currentProcessStepType,
      "recipient-email": _ctx.recipientEmail,
      "template-variables": _ctx.templateVariables,
      onClose: _ctx.closeEmailReviewModal,
      onSendSuccess: _ctx.handleEmailSent
    }, null, 8, ["is-open", "process-step-type", "recipient-email", "template-variables", "onClose", "onSendSuccess"]),
    _createVNode(_component_SpreadsheetReviewModal, {
      "is-open": _ctx.showSpreadsheetReviewModal,
      "document-data": _ctx.selectedDocument || {},
      onClose: _ctx.closeSpreadsheetReviewModal,
      onSave: _ctx.handleSpreadsheetSaved
    }, null, 8, ["is-open", "document-data", "onClose", "onSave"])
  ]))
}